import DocumentDetails from "../GridDataComponent/DocumentDetails";
import "../../CriminalCertificateValidation.css";

const  BusinessCardDetails = () =>{
  return(
<DocumentDetails documentType={'business-cards'} keyAccess={'prebuilt-businessCard'} title={'Business Card'} exportDataToExcelName={'Businesscard Document'} analysefrom={'business-card'} deleteText={'business-card'}modelName={'doc-ai'} webSocketName={'businesscard'}/>
  )
 };
 export default BusinessCardDetails;